import Vue from 'vue'
let vue = new Vue()
let baseUrl = vue.$cdn

export default{
  introduce: {
    title: 'World’s First Consumer 3D Camera',
    price: 'USD 699',
    dec: 'Takes 10 minutes to reconstruct a space (100 m²), which is only 1/20 of the time needed for conventional devices, provides 4K HD picture quality and immersive virtual strolling of real 3D spaces.',
    btn: 'Buy it on Alibaba',
    subTitle: 'Powerful Tool for Realistic 3D Space Reconstruction',
    benefitGroup: [
      {
        fontImg: 'icon-koudai',
        icon: baseUrl + 'images/product_img_02_a@2x.png',
        title: 'Light, portable<br/>and pocket-sized',
        content:
          'The same size as mobile phone at 115g, 4DKanKan is 1/30 the weight of existing products.'
      },
      {
        fontImg: 'icon-jianmo',
        icon: baseUrl + 'images/product_img_02_b@2x.png',
        title: 'Easy operation <br/>and efficient reconstruction',
        content:
          'No expertise required. 100 square meters of spatial data can be collected in 10 minutes. Upload it to the cloud in one click, and the model is automatically generated within 5 minutes.'
      },
      {
        fontImg: 'icon-manyou',
        icon: baseUrl + 'images/product_img_02_c@2x.png',
        title: 'High-precision spatial <br/>reconstruction and exploration',
        content:
          'Scenes are reconstructed in realistic 3D. View models in 4K and 720 degrees, and explore space through an immersive experience.'
      },
      {
        fontImg: 'icon-paise',
        icon: baseUrl + 'images/product_img_02_d@2x.png',
        title: 'Indoor and <br/>outdoor shooting',
        content:
          'Shoots both indoors and outdoors. Data collection is no longer restricted by environment.'
      },
      {
        fontImg: 'icon-genxing',
        icon: baseUrl + 'images/product_img_02_e@2x.png',
        title: 'Edit freely<br/>update anytime',
        content:
          'Model editing platform supports adding and updating annotations including images, texts, videos and links.'
      }
    ]
  },
  app: {
    title: '4DKankan App',
    sub: ['快速编辑和分享你的互动式视频', '分享你的空间故事']
  },
  guide: [
    {
      title: [
        'High-definition Reconstruction',
        'The AI space reconstruction algorithm precisely reconstructs the real space to provide virtual strolling, giving you the feeling that you are in the real scene.'
      ]
    },
    {
      title: ['Reconstruct Space Conveniently in Three Steps', 'Connect to a camera, shoot and upload to reconstruct the space. Easy to get started and requires no professional training.'],
      sub: ['Upload to the cloud', 'Shoot with 4DKanKan Lite', 'Space display in the user’s end']
    },
    {
      title: ['Instant and Automatic Generation of 3D Space', 'Data in a 100㎡ space can be collected in 10 minutes, and its digital 3D space generated in 5 minutes.']
    },
    {
      title: ['Edit and Share Interactive 3D Spaces', 'You can easily add multimedia hotspots in 3D spaces, such as images, text, audio guides, hyperlinks etc.']
    }
  ],
  technology: {
    title: 'Precise, Intelligent, Exquisite, Lightweight',
    dec: '4DKanKan Lite is made of 892 individual components in a sleek and compact design.'
  },
  parmas: {
    name: 'Detailed Parameters of 4DKanKan Lite'
  },
  standardGroup: {
    label: 'Model',
    name: '4DKanKan Lite',
    info: [
      {
        label: 'Height',
        value: '130mm'
      },
      {
        label: 'Width',
        value: '47mm'
      },
      {
        label: 'Depth',
        value: '18mm'
      },
      {
        label: 'Weight',
        value: '115g'
      }
    ],
    params1: [
      {
        label: 'Fabric',
        value: ['Titanium', 'Matte surface']
      },
      {
        label: 'Camera',
        value: [
          'f/2.0 aperture',
          '3200-pixels SONY sensor',
          '220° fisheye lens*2',
          'Optical lens*8',
          '30fps recording speed in 3K'
        ]
      },
      {
        label: 'Connection',
        value: ['Bluetooth: 5.0', 'WiFi：802.11a / b / g / n / ac']
      }
    ],
    params2: [
      {
        label: 'Battery',
        value: ['2000mAh', 'Quick charge through USB']
      },
      {
        label: 'Storage',
        value: ['128G Trans-flash Card', '120-minutes 3K video']
      },
      {
        label: 'Interface',
        value: ['microUSB', 'Tripod attachment hole']
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/store/language/en/binocular.js